import { render } from "./CadastroCompany.vue?vue&type=template&id=489cd4db&scoped=true"
import script from "./CadastroCompany.vue?vue&type=script&lang=js"
export * from "./CadastroCompany.vue?vue&type=script&lang=js"

import "./CadastroCompany.vue?vue&type=style&index=0&id=489cd4db&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489cd4db"]])

export default __exports__